import { sentenceCase } from "change-case";
import { useState } from "react";
import styled, { RuleSet } from "styled-components";

import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Vervestatus } from "codegen";
import { defaultStyle, errorStyle, Filter, greenStyle, yellowStyle } from "pages/Strombestilling/components/Filter";
import { Tooltip, TooltipText } from "pages/Strombestilling/orders/components/OrderStatus";

interface VervingStatusProps {
	status: Vervestatus;
	onClick?: () => void;
}
export function VervingStatus({ status, onClick }: Readonly<VervingStatusProps>) {
	const [hovered, setHovered] = useState(false);
	return (
		<Tooltip>
			<VervingFilter as={onClick ? "button" : "div"} onClick={onClick} $status={status}>
				{sentenceCase(status)}
				{onClick && <FontAwesomeIcon icon={faInfoCircle} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} />}
			</VervingFilter>
			<TooltipText visible={hovered}>{tooltipMap.get(status)}</TooltipText>
		</Tooltip>
	);
}

const VervingFilter = styled(Filter) <{ $status: Vervestatus; onClick: boolean }>`
	${({ $status }) => colorMap.get($status) ?? defaultStyle};
	&:hover {
		opacity: ${(props) => (props.onClick ? 0.7 : 1)};
	}
`;

const tooltipMap: Map<Vervestatus, string> = new Map([
	[Vervestatus.Opprettet, "Den som blir vervet har fullført strømbestilling, inkludert registrering av målernummer eller målepunkt-ID."],
	[Vervestatus.Manuell, "Denne vervinga er tatt ut av den automatiske flyten og blir håndtert hel-manuelt."],
	[
		Vervestatus.Utbetalt,
		"Én måned etter at vervingen er opprettet gjøres det en sjekk om verver og venn kan motta vervepremie, da settes denne statusen. Selve utbetalingen kommer på første mulige faktura etter statusen er satt.",
	],
	[
		Vervestatus.Avvist,
		"Vervingen kan ikke utbetales. Vanlig årsak er at den vervede avslutter strømavtalen før det er gått én måned eller bytter oppstartsdato på strømavtalen.",
	],
	[Vervestatus.Forlatt, "Verver har forlatt NTE før premien er utbetalt. Ververabatten til den vervede blir likevel utbetalt."],
]);

const colorMap: Map<Vervestatus, RuleSet<object>> = new Map([
	[Vervestatus.Opprettet, yellowStyle],
	[Vervestatus.Manuell, defaultStyle],
	[Vervestatus.Utbetalt, greenStyle],
	[Vervestatus.Avvist, errorStyle],
	[Vervestatus.Forlatt, yellowStyle],
]);
